import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@/components/ui/button';

const Pagination = ({ page, totalPages, onPrev, onNext }) => {
  return (
    <div className="flex items-center justify-between mt-6 text-sm text-gray-600">
      <p>
        Page <span className="font-medium">{page}</span> sur <span className="font-medium">{totalPages}</span>
      </p>

      <div className="flex gap-2">
        <Button variant="outline" size="sm" onClick={onPrev} disabled={page === 1} className="rounded-lg">
          Précédent
        </Button>

        <Button variant="outline" size="sm" onClick={onNext} disabled={page === totalPages} className="rounded-lg">
          Suivant
        </Button>
      </div>
    </div>
  );
};

Pagination.propTypes = {
  page: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  onPrev: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
};

export default Pagination;
